module.exports = __webpack_public_path__ + "static/media/IMG_3897 - Copy (2).8bcebb63.JPG";